import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar  from './Topbar';
import Footer  from './Footer';
import styles  from './Layout.module.css';

function OrientationBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const check = () => {
      const mobile = window.innerWidth <= 768;
      const portrait = window.innerHeight > window.innerWidth;
      setShow(mobile && portrait);
    };
    check();
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, []);
  if (!show) return null;
  return (
    <div className={styles.orientationBanner}>
      <span>📱</span>
      <span>Para una mejor experiencia, gira tu dispositivo en horizontal</span>
    </div>
  );
}

export default function Layout() {
  const isMobile = () => window.innerWidth <= 768;
  const [open, setOpen] = useState(!isMobile()); // cerrado por defecto en móvil
  const { pathname } = useLocation();

  // Cerrar sidebar al navegar en móvil
  useEffect(() => {
    if (isMobile()) setOpen(false);
  }, [pathname]);

  // Ajustar sidebar al cambiar tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      if (!isMobile()) setOpen(true);
      else setOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nopadPages = ['/mensajes'];
  const isNoPad = nopadPages.some(p => pathname.includes(p));

  return (
    <div className={styles.shell} data-sidebar={open ? 'open' : 'closed'}>
      <Sidebar open={open} onClose={() => setOpen(false)} />

      {/* Backdrop para cerrar sidebar en móvil */}
      <div className={styles.backdrop} onClick={() => setOpen(false)} />

      <div className={styles.main}>
        <OrientationBanner />
        <Topbar onToggle={() => setOpen(p => !p)} />
        <div className={`${styles.content} ${isNoPad ? styles.contentNoPad : ''}`}>
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}
